import { render, staticRenderFns } from "./FormLayoutVerticalIcon.vue?vue&type=template&id=b3ed1a9a&"
import script from "./FormLayoutVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./FormLayoutVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports